import { ApplicationResultContent } from '../../components/ApplicationResultContent';

export const OrganizationApplicationRejected = () => {
  return (
    <ApplicationResultContent
      title="Here's an update on your application"
      description={
        <div>
          <div>
            We truly appreciate the important work your organization is doing. While you're not
            eligible for this program, we're grateful for the time, care, and insight you shared in
            your application.
          </div>
          <div>
            If you'd like feedback on your application, feel free to{' '}
            <a href='mailto:support@movingworlds.org' className='text-brand-500 underline'>
              reach out
            </a>{' '}
            - we'd be happy to support your learning process.
          </div>
        </div>
      }
    />
  );
};
